var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"title-table-presentation-tooltip result-layout-tooltip ml-2"},[_c('b-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
      content :_vm.tooltipContent,
      delay : {show : 0 , hide : 600},
      html : true
    }),expression:"{\n      content :tooltipContent,\n      delay : {show : 0 , hide : 600},\n      html : true\n    }"}],staticClass:"tooltip-btn"}),_c('i',{staticClass:"fas fa-question-circle"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }